import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PayFlagIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23.59 14.53L19.97 10L23.59 5.47C23.99 5.01 23.61 4.23 23 4.25H14.75V2C14.75 1.59 14.41 1.25 14 1.25H2.75V1C2.75 0.59 2.41 0.25 2 0.25C1.59 0.25 1.25 0.59 1.25 1V23C1.25 23.41 1.59 23.75 2 23.75C2.41 23.75 2.75 23.41 2.75 23V12.75H9.25V15C9.25 15.41 9.59 15.75 10 15.75H23C23.61 15.77 23.98 15 23.59 14.53ZM2.75 11.25V2.75H13.25V11.25H2.75ZM10.75 14.25V12.75H14C14.41 12.75 14.75 12.41 14.75 12V5.75H21.44L18.41 9.53C18.19 9.8 18.19 10.19 18.41 10.47L21.44 14.25H10.75Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PayFlagIcon.displayName = 'PayFlagIcon';
